import React from 'react'
import { useData } from './DataProvider'
import { Stepper, Step, StepIndicator, Sheet } from '@mui/joy'
import { Check, Circle } from '@mui/icons-material'
import useTranslation from '../shared/TranslationProvider'
import useTheme from '../shared/ThemeProvider'

const StepperDisplay = () => {
  const { step } = useData()
  const { t } = useTranslation()
  const { secondaryColor } = useTheme()
  // The visual stepper is decorative (see aria-hidden below); the nav landmark
  // label conveys progress as a single "Step X of 5 steps" instead of reading
  // every step label individually.
  const steps = [1, 2, 3, 4, 5].map((stepNum) => {
    const isCompleted = stepNum < step
    const isActive = stepNum === step

    return (
      <Step
        key={stepNum}
        orientation="vertical"
        completed={isCompleted}
        active={isActive}
        indicator={
          <StepIndicator
            variant={isCompleted ? 'solid' : 'outlined'}
            color={isCompleted ? 'success' : 'neutral'}
            aria-hidden="true"
          >
            {isCompleted && <Check aria-hidden="true" />}
            {isActive && <Circle color="success" aria-hidden="true" />}
          </StepIndicator>
        }
      >
        {t('step')} {stepNum}
      </Step>
    )
  })

  return (
    <Sheet
      variant="outlined"
      className="stepper-container"
      data-testid="a11y-onboarding--stepper"
    >
      {/* Progress is spoken via sr-only h2 on each step (aria-describedby on h1).
          The visual stepper is decorative. */}
      <Stepper
        aria-hidden="true"
        className="!mx-auto max-w-3xl"
        size="lg"
        sx={{
          '--joy-palette-success-solidBg': secondaryColor,
          '.MuiSvgIcon-colorSuccess': { color: secondaryColor },
        }}
      >
        {steps}
      </Stepper>
    </Sheet>
  )
}
export default StepperDisplay
